module.exports = __webpack_public_path__ + "img/Semua_orabg_meminjam.1568adaa.png";